import pattern from 'patternomaly'

const CHART_COLORS = '556270 4ecec4 c7f464 ff6b6b c44d58 ff8002 ff5c44 ff3f6f e63b95 b94ab2 7b58c2 0060c0'.split(' ').map(c => `#${c}`)

const CHART_PATTERNS_RANKED = [
  'line-vertical',
  'zigzag',
  'zigzag-vertical',
  'diagonal',
  'diagonal-right-left',
  'line',
  'dot',
  'plus',
  'cross',
  'square',
  'dash',
  'cross-dash',
]

export function generatePatternColors(count) {
  const patterns = []
  for (let i = 0; i < count; i++) {
    const patternName = CHART_PATTERNS_RANKED[i % CHART_PATTERNS_RANKED.length]
    const color = CHART_COLORS[i % CHART_COLORS.length]
    patterns.push(pattern.draw(patternName, color))
  }
  return patterns
}

export function applyPatternsToChart(chartId) {
  if (typeof window.Chartkick === 'undefined' || !window.Chartkick) {
    return false
  }

  const chartkickChart = window.Chartkick.charts[chartId]
  if (!chartkickChart) {
    return false
  }

  // Get the underlying Chart.js instance
  const chart = chartkickChart.chart || chartkickChart.__chart
  if (!chart) {
    return false
  }

  // Get data count from the first dataset
  const dataCount = chart.data?.datasets?.[0]?.data?.length || 0
  if (dataCount === 0) {
    return false
  }

  const patternColors = generatePatternColors(dataCount)
  
  // Apply patterns to all datasets
  chart.data.datasets.forEach((dataset) => {
    dataset.backgroundColor = patternColors
  })

  chart.update()
  return true
}

// Export to window for easy access from inline scripts
if (typeof window !== 'undefined') {
  window.ChartPatterns = {
    generatePatternColors,
    applyPatternsToChart
  }
}
